module.exports = __webpack_public_path__ + "img/portrait-014.3aca8c96.jpg";